import Link from 'next/link';
import Col from 'antd/lib/col';
import Row from 'antd/lib/row';

import { IGame, IGameDetail } from 'src/interface';

import { ButtonPrimary } from '../Button';
import Divider from '../Divider';
import ImageC from '../Image';
import ModalC, { ModalCProps } from '../Modal';

import classes from './index.module.less';

interface Props extends ModalCProps {
	data?: IGameDetail | IGame;
}

const ModalPlayGame = ({ open, data, onClose }: Props) => {
	return (
		<ModalC className={classes.modal} open={open} onClose={onClose}>
			<div className={classes.container}>
				<Row gutter={30}>
					<Col span={6}>
						<div className={classes.image}>
							<ImageC
								alt={`icon ${data?.name}`}
								className={classes.img}
								src={data?.icon_image_url}
							/>
						</div>
					</Col>
					<Col span={18}>
						<Row gutter={30}>
							<Col span={24}>
								<h1>{data?.name}</h1>
							</Col>
							<Col span={24}>
								<Divider color="#5A5A5A" />
							</Col>
							<Col span={24}>
								<div className={classes.data}>
									<div>
										<label className="fs-16 fw-400">Chain</label>
										<div className="d-flex mt-1" style={{ gap: 6 }}>
											{data?.chains?.map((c) => (
												<ImageC
													alt={`icon ${c?.name}`}
													key={c.chain_id}
													width={24}
													height={24}
													src={c.image_url}
												/>
											))}
										</div>
									</div>
									<div>
										<label className="fs-16 fw-400">Platform</label>
										<div className="d-flex mt-1" style={{ gap: 10 }}>
											{data?.platform?.toLowerCase() === 'coming soon' ? (
												<span>Coming Soon</span>
											) : (
												data?.platform
													?.split(',')
													?.map((p) => (
														<ImageC
															key={p}
															alt={`icon ${p}`}
															width={24}
															height={24}
															src={`/icons/icon-platform-${p.toLowerCase()}.svg`}
														/>
													))
											)}
										</div>
									</div>
								</div>
							</Col>
						</Row>
					</Col>
					<Col span={24}>
						<div className={classes['link-btn-container']}>
							{data?.web_game_link && (
								<Link href={data?.web_game_link} target="_blank" rel="noopener noreferrer">
									<ButtonPrimary className={classes.btn}>Play Game</ButtonPrimary>
								</Link>
							)}
							{data?.play_store_link && (
								<Link href={data?.play_store_link} target="_blank" rel="noopener noreferrer">
									<ButtonPrimary className={classes.btn}>Google Play</ButtonPrimary>
								</Link>
							)}
							{data?.app_store_link && (
								<Link href={data?.app_store_link} target="_blank" rel="noopener noreferrer">
									<ButtonPrimary className={classes.btn}>App Store</ButtonPrimary>
								</Link>
							)}
							{data?.apk_download_link && (
								<Link href={data?.apk_download_link} target="_blank" rel="noopener noreferrer">
									<ButtonPrimary className={classes.btn}>Download Game</ButtonPrimary>
								</Link>
							)}
							{data?.official_site_link && (
								<Link href={data?.official_site_link} target="_blank" rel="noopener noreferrer">
									<ButtonPrimary className={classes.btn}>Official Website</ButtonPrimary>
								</Link>
							)}
						</div>
					</Col>
				</Row>
			</div>
		</ModalC>
	);
};

export default ModalPlayGame;
